import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ChatContextItem } from "../api";
import { AudioState } from "./audio-player";
import { closeIcon } from "../utils/icons";
import { BaseElement } from "../utils/ui-components";

export interface PreviewContext {
    context: ChatContextItem;
    subtitleIndex?: number;
    highlightSegment?: boolean;
    matches: {
        type: string;
        segmentIndex: number;
        highlights: {
            text: string;
            title?: string;
        };
    }[];
}

@customElement("preview-overlay")
export class PreviewOverlay extends BaseElement {
    @property()
    previewContext!: PreviewContext;

    @property()
    onAudioRequest?: (state: AudioState) => void;

    @property()
    onClose!: () => void;

    render() {
        return html`
            <div class="fixed inset-0 bg-gray-600/50 z-50 flex items-center justify-center p-4 sm:p-4">
                <div class="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-screen sm:max-h-[calc(100vh-250px)] flex flex-col h-full sm:h-auto">
                    <div class="p-4 pb-2 flex justify-end">
                        <button @click=${this.onClose} class="text-gray-400 hover:text-gray-600">
                            <i class="w-5 h-5 icon">${closeIcon}</i>
                        </button>
                    </div>
                    <div class="p-4 pt-0 overflow-y-auto">
                        <search-hit-view
                            .hit=${{
                                item: this.previewContext.context.item,
                                matches: this.previewContext.matches,
                            }}
                            .onAudioRequest=${this.onAudioRequest}
                            .inPreview=${true}
                        ></search-hit-view>
                    </div>
                </div>
            </div>
        `;
    }
}
